import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ProductListService } from 'src/app/service/product-list.service';
import { ProductServiceService } from 'src/app/service/product-service.service';

@Component({
    selector: 'app-trending-products',
    templateUrl: './trending-products.component.html',
    styleUrls: ['./trending-products.component.scss']
})
export class TrendingProductsComponent implements OnInit {

    singleProductsBox=[];
    constructor(private productService:ProductServiceService) {
       //Get Trending Produscts
       /* this.productService.getNewProductsByStatus(productService.trending_status).subscribe(res=>{
            this.singleProductsBox = res;
        })*/

        this.productService.getProductsByType(productService.mirrorless_cameras).subscribe(res=>{
            this.singleProductsBox = res;
        })

       
     }

    ngOnInit(): void {
    }

    sectionTitle = [
        {
            title: "Mirrorless Cameras",
           // title: "Trending This Week",
            //paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida."
        }
    ]
   
    productsSlidesOptions: OwlOptions = {
		loop: true,
		nav: false,
		dots: true,
		autoplayHoverPause: true,
		autoplay: true,
		margin: 30,
		navText: [
			"<i class='bx bx-left-arrow-alt'></i>",
			"<i class='bx bx-right-arrow-alt'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 2
			},
			992: {
				items: 3
			},
			1200: {
				items: 3
			}
		}
    }

}